(function() {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ModalConfirmCtrl', ModalConfirmCtrl);

    ModalConfirmCtrl.$inject = ['$scope', '$modalInstance', 'message', 'title', 'yesNoVariation'];

    /**
     * Controller for a confirmation dialog.
     */
    function ModalConfirmCtrl($scope, $modalInstance, message, title, yesNoVariation) {
        $scope.message = message;
        $scope.title = title;
        $scope.confirm = 'Continue';
        $scope.deny = 'Cancel';

        if (yesNoVariation) {
            $scope.confirm = 'Yes';
            $scope.deny = 'No';
        }

        /**
         * Closes the dialog with an affirmative (OK) choice.
         */
        $scope.ok = function() {
            $modalInstance.close('ok');
        };

        /**
         * Closes the dialog with an negative (Cancel) choice.
         */
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
    }
})();